export const ATTACHMENT_COMMON_EXTENSIONS =
  '.png, .jpg, .jpeg, .heic, .csv, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf';

export const ATTACHMENT_IMAGE_EXTENSIONS = '.png, .jpg, .jpeg';
